import { render, staticRenderFns } from "./ListOrders.vue?vue&type=template&id=5df1ceb1&scoped=true"
import script from "./ListOrders.vue?vue&type=script&lang=js"
export * from "./ListOrders.vue?vue&type=script&lang=js"
import style0 from "./ListOrders.vue?vue&type=style&index=0&id=5df1ceb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df1ceb1",
  null
  
)

export default component.exports